export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    TaskInfo: ['TaskInfoFailed', 'TaskInfoFinished', 'TaskInfoPending', 'TaskInfoProcessing'],
  },
};
export default result;
